export function Textarea({ ...props }) {
  return (
    <textarea
      {...props}
      className="w-full border rounded p-2 text-sm font-mono"
    />
  );
}